module.exports = __webpack_public_path__ + "img/instagram.84605c9d.svg";